import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from '../../baseQuery';

export type AlertEvent = string;

export const alertsApi = createApi({
  reducerPath: 'alertsApi',
  tagTypes: ['Alerts'],
  keepUnusedDataFor: 300,
  baseQuery: baseQueryWithReauth(),
  endpoints: (build) => ({
    getAlerts: build.query<string[], void>({
      query: () => ({
        url: `/alerts`,
        method: 'GET',
      }),
      providesTags: () => ['Alerts'],
    }),
  }),
});

export const { useGetAlertsQuery } = alertsApi;
